import { ACCESS } from "constants/accessPermissions"

export const ACCOUNT_WORKSPACE_ACCESS = [
  ACCESS.ACCOUNT_MANAGEMENT.VIEW,
  ACCESS.ACCOUNT_VENDOR_BILL.VIEW_LIST,
  ACCESS.ACCOUNT_VENDOR_PAYMENT.VIEW_LIST,
  ACCESS.ACCOUNT_CUSTOMER_PAYMENT.VIEW_LIST,
  ACCESS.ACCOUNT_LOAN.VIEW_LIST,
  ACCESS.ACCOUNT_LOAN_REPAYMENT.VIEW_LIST,
  ACCESS.ACCOUNT_TRANSACTION.VIEW_LIST,
  ACCESS.ACCOUNT_EXPENSE.VIEW_LIST,
  ACCESS.ACCOUNT_FUND_TRANSFER.VIEW_LIST,
  ACCESS.ACCOUNT.VIEW_LIST,
  ACCESS.ACCOUNT_PAYMENT_METHOD.VIEW_LIST,
  ACCESS.ACCOUNT_ACCOUNT_TYPE.VIEW_LIST,
  ACCESS.ACCOUNT_TRANSACTION_TYPE.VIEW_LIST,
  ACCESS.ACCOUNT_EXPENSE_TYPE.VIEW_LIST,
  ACCESS.ACCOUNT_LOAN_STATUS.VIEW_LIST,
  ACCESS.ACCOUNT_BILL_STATUS.VIEW_LIST,
  ACCESS.ACCOUNT_VENDOR.VIEW_LIST,
  ACCESS.ACCOUNT_VEHICLE_PURCHASE.VIEW_LIST,
  ACCESS.ACCOUNT_IMPORTER_PAYMENT.VIEW_LIST,
  ACCESS.ACCOUNT_AUDIT_LOG.VIEW_LIST,
  ACCESS.ACCOUNT_API_STATUS.VIEW,
]

export const ACCOUNT_WORKSPACE_TABS = [
  {
    id: "overview",
    label: "Overview",
    icon: "mdi mdi-view-dashboard-outline",
    access: ACCOUNT_WORKSPACE_ACCESS,
  },
  {
    id: "payables",
    label: "Payables",
    icon: "mdi mdi-file-document-multiple-outline",
    access: [ACCESS.ACCOUNT_VENDOR_BILL.VIEW_LIST, ACCESS.ACCOUNT_VENDOR_PAYMENT.VIEW_LIST],
  },
  {
    id: "receivables",
    label: "Receivables",
    icon: "mdi mdi-cash-check",
    access: [ACCESS.ACCOUNT_CUSTOMER_PAYMENT.VIEW_LIST],
  },
  {
    id: "loans",
    label: "Loans",
    icon: "mdi mdi-cash",
    access: [ACCESS.ACCOUNT_LOAN.VIEW_LIST, ACCESS.ACCOUNT_LOAN_REPAYMENT.VIEW_LIST],
  },
  {
    id: "cash-bank",
    label: "Cash & Bank",
    icon: "mdi mdi-bank-outline",
    access: [
      ACCESS.ACCOUNT.VIEW_LIST,
      ACCESS.ACCOUNT_EXPENSE.VIEW_LIST,
      ACCESS.ACCOUNT_FUND_TRANSFER.VIEW_LIST,
      ACCESS.ACCOUNT_VEHICLE_PURCHASE.VIEW_LIST,
      ACCESS.ACCOUNT_IMPORTER_PAYMENT.VIEW_LIST,
    ],
  },
  {
    id: "ledger",
    label: "Ledger",
    icon: "mdi mdi-book-open-page-variant-outline",
    access: [ACCESS.ACCOUNT_TRANSACTION.VIEW_LIST],
  },
  {
    id: "setup",
    label: "Setup",
    icon: "mdi mdi-cog-outline",
    access: [
      ACCESS.ACCOUNT.VIEW_LIST,
      ACCESS.ACCOUNT_VENDOR.VIEW_LIST,
      ACCESS.ACCOUNT_PAYMENT_METHOD.VIEW_LIST,
      ACCESS.ACCOUNT_ACCOUNT_TYPE.VIEW_LIST,
      ACCESS.ACCOUNT_TRANSACTION_TYPE.VIEW_LIST,
      ACCESS.ACCOUNT_EXPENSE_TYPE.VIEW_LIST,
      ACCESS.ACCOUNT_LOAN_STATUS.VIEW_LIST,
      ACCESS.ACCOUNT_BILL_STATUS.VIEW_LIST,
    ],
  },
  {
    id: "admin",
    label: "Admin",
    icon: "mdi mdi-shield-account-outline",
    access: [ACCESS.ACCOUNT_AUDIT_LOG.VIEW_LIST, ACCESS.ACCOUNT_API_STATUS.VIEW],
  },
]

export const getVisibleWorkspaceTabs = hasAnyPermission =>
  ACCOUNT_WORKSPACE_TABS.filter(tab => hasAnyPermission(tab.access))
